<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Consulta De Producto
            </v-card-title>
            <v-container fluid grid-list-sm>
                  <v-row dense>
                        <v-col cols="12" sm="12">
                              <ModalConsultaProductoComponent :open="obModal.open" :objeto="obModal" />
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Seguros *" color="textbox" v-model="obSearch.idSeguro"
                                    :items="listGeneral.listSeguro" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                                    item-text="nombre_estado" item-value="id_estado"
                                    :items="listGeneral.listEstado" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                              <v-tooltip top color="primary">
                                    <template v-slot:activator="{ on }">
                                          <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                                :disabled="disabled">
                                                <v-icon dark>search</v-icon>
                                          </v-btn>
                                    </template>
                                    <span>Buscar</span>
                              </v-tooltip>
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12" sm="6"/>
                        <v-col cols="12" sm="6">
                              <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                              prepend-inner-icon="search" dense/>
                        </v-col>
                  </v-row>

                  <v-row dense>
                        <v-col cols="12">
                              <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"
                                    :items="listGeneral.detalle" class="elevation-3">
                              
                                    <template v-slot:item.name="{ item }">
                                          <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                                <v-icon small>edit</v-icon>
                                          </v-btn>
                                    </template>
                                    
                                    <template v-slot:no-results>
                                          Tu búsqueda de "<span v-text="obSearch.search"></span>" no arrojó resultados.
                                    </template>
                              </v-data-table>
                        </v-col>
                  </v-row>

            </v-container>
      </v-card>
</template>

<script>
      export default {
            name: 'ConsultaProductoView',
            components:{
                  ModalConsultaProductoComponent: () => import('@/components/consulta/producto/ModalConsultaProductoComponent.vue')
            },
            data: () => ({
                  obSearch:{
                        idSeguro:null,
                        idEstado:null,
                        search:''
                  },
                  obModal:{
                        titulo:'Información Consulta Producto',
                        open:null,
                        idEstado:null,
                  },
                  listGeneral:{},
                  parametros:{},
                  disabled:false
            }),
            created(){
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/consulta-producto/cargaGeneral`)
                        .then((r) =>{
                              if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                              if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    this.$set(this,'listGeneral', r.data.data.listas);
                                    this.$set(this,'parametros', r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    return this.onListar('L');
                        })
                        .catch((e) =>{
                              mensajesAlerta(e, error);
                        });
            },
            methods:{
                  onListar(ev){
                        if(!_.isUndefined(ev)){
                              var o = _.merge({ opcion:'L_PRO_X_SEG'},_.omit(this.obSearch,'search'));
                              var error = 'E';

                              this.listGeneral.detalle = [];
                              axios.post(`${BASE_URI}administrador/producto/listar`,o)
                                    .then((r) =>{
                                          if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                          if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                this.listGeneral.detalle = r.data.data;
                                    })
                                    .catch((e) =>{
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  ver(v){
                        this.$set(this,'obModal',_.merge({},this.obModal,v,{open:true,titulo:'Información Consulta Producto'}));
                  },
                  close(){
                        this.obModal = {
                              open:false,
                              titulo:'Información Consulta Producto',
                              idEstado: _.toString(this.parametros.id_estado_default)
                        }
                  }
            },
            provide(){
                  return{
                        close:this.close
                  }
            }
      }
</script>